import { render } from "./ReplyResponseButton.vue?vue&type=template&id=0bc84144&ts=true"
import script from "./ReplyResponseButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyResponseButton.vue?vue&type=script&lang=ts&setup=true"

import "./ReplyResponseButton.vue?vue&type=style&index=0&id=0bc84144&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyResponseButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bc84144"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bc84144', __exports__)) {
    api.reload('0bc84144', __exports__)
  }
  
  module.hot.accept("./ReplyResponseButton.vue?vue&type=template&id=0bc84144&ts=true", () => {
    api.rerender('0bc84144', render)
  })

}


export default __exports__